import { useAppSelector } from 'store';
import {
  composableFiltersState,
  MainOperatorEnum,
} from 'store/composableFiltersSlice';

interface ClausePrefixProps {
  index: number;
  handleSelectOperator: Function;
}

export const ClausePrefix = ({
  index,
  handleSelectOperator,
}: ClausePrefixProps) => {
  const { selected } = useAppSelector(composableFiltersState);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const selectBaseStyles = {
    input: (base: any) => ({
      ...base,
      'input:focus': {
        boxShadow: 'none',
      },
    }),
    control: (base: any) => ({
      ...base,
      backgroundColor: '#F8F8F8',
      border: 'none',
      borderRadius: '8px',
      height: '48px',
      width: '83px',
      textTransform: 'capitalize',
    }),
    menu: (base: any) => ({
      ...base,
    }),
    indicatorSeparator: () => ({}),
    valueContainer: (base: any) => ({
      ...base,
      paddingLeft: '16px',
    }),
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const operatorOptions = [
    {
      value: MainOperatorEnum.And,
      label: 'And',
    },
    {
      value: MainOperatorEnum.Or,
      label: 'Or',
    },
  ];

  if (index === 0) {
    return <p className="text-right">Where</p>;
  }
  // * Operator disabled temporarily
  // if (index === 1) {
  //   return (
  //     <Select
  //       className=""
  //       value={{
  //         value: selected.filters.mainOperator,
  //         label: selected.filters.mainOperator as string,
  //       }}
  //       isSearchable={false}
  //       options={operatorOptions}
  //       onChange={(selectedOption) => {
  //         handleSelectOperator(selectedOption);
  //       }}
  //       styles={selectBaseStyles}
  //     />
  //   );
  // }
  if (index >= 1) {
    return (
      <p className="text-right capitalize">{selected.filters.mainOperator}</p>
    );
  }

  return null;
};
